import React from 'react'

const IconForward = ({size, onClick, style, color, className}) => {
    return (
        <svg className={className} width={size} height={size} onClick={onClick} style={style} viewBox="0 0 24 24" fill="none">
            <path d="M9 19L16 12L9 5" stroke={color ? color : "white"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default IconForward
